import { Name } from '@ori-events/request-favorites';
import { useCallback } from 'react';

import { useDebouncedAddEventListener } from './useDebouncedAddEventListener';
import type { useFavorites } from './useFavorites';
import { dispatchFavoritesUpdatedEvent } from '../utils';

export const useRequestEvent = (request: ReturnType<typeof useFavorites>['request']) => {
  const onRequest = useCallback(() => {
    request()
      .then(({ favorites }) => dispatchFavoritesUpdatedEvent({ favorites, lastUpdated: null }))
      // eslint-disable-next-line no-console -- log error to console
      .catch(console.error);
  }, [request]);
  useDebouncedAddEventListener(Name, onRequest);
};
